/**
 * @fileoverview Fecha um dropdown/popover hand-rolled ao clicar fora do
 * elemento referenciado ou ao apertar Escape. Só registra listeners enquanto
 * `active` for true.
 *
 * Uso:
 *   const ref = useRef(null);
 *   useClickOutside(ref, open, () => setOpen(false));
 *   <div ref={ref}>…trigger + menu…</div>
 */
import { useEffect } from "react";

export function useClickOutside(ref, active, onClose) {
  useEffect(() => {
    if (!active) return undefined;
    const onMouseDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("mousedown", onMouseDown);
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("mousedown", onMouseDown);
      window.removeEventListener("keydown", onKeyDown);
    };
    // onClose costuma ser uma arrow inline; re-registrar a cada render é barato
    // e evita exigir useCallback em todos os chamadores.
  }, [ref, active, onClose]);
}

export default useClickOutside;
